import React, { useState, useEffect } from 'react'
import Form from '@/components/Form'
import useSiteContext from '@/context/SiteContext'
import { obtainAll, optInThirdParty } from '@/components/useFunctions'
import { getQueryParams, clearQueryParam } from 'react-use-query-param-string'
import { Optin } from '@/components/Form/Optin'
import Newsletters from '@/components/Newsletters'

const DefaultSecondStep = ({ email }) => {
  return (
    <span className="block text-3xl leading-tight">
      Ahora elige los newsletters que quieras. Te llegarán todos a{' '}
      <i className="not-italic underline">{email}</i>.
      <Optin />
    </span>
  )
}

const DefaultReveal = ({ newsletters }) => {
  return <Newsletters newsletters={newsletters} />
}

const Steps = ({
  Reveal = DefaultReveal,
  firstStep = 'Ingresa tu correo electrónico',
  SecondStep = DefaultSecondStep,
  newsletters,
}) => {
  const {
    email,
    saveEmail,
    triggerUnsubscribe,
    setTriggerUnsubscribe,
    optin,
    setOptin,
    clearSubscriptions,
    addSubscriptions,
    setCanSubscribeToLT,
    setCanSubscribeToPC,
  } = useSiteContext()
  const [hasEmailSubscription, setHasEmailSubscription] = useState(false)

  const handleSubscriptionDataFromServer = (data, newsletters) => {
    console.log('handleSubscriptionDataFromServer asdf', data)
    console.log('handleSubscriptionDataFromServer newsletters', newsletters)
    if (data.length > 0) {
      const accumulator = []
      data.map(item => {
        const { name, status } = item
        const newsletter = newsletters.find(obj => obj.field === name)
        if (status && newsletter) {
          accumulator.push(newsletter)
        }
      })
      addSubscriptions(accumulator)
    }
  }

  useEffect(() => {
    const { email, unsubscribe } = getQueryParams()
    if (
      email?.length > 0 &&
      email?.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
    ) {
      saveEmail(email)
      clearQueryParam('email')
    }
    if (unsubscribe && unsubscribe === 'true') {
      setTriggerUnsubscribe(true)
      clearQueryParam('unsubscribe')

      // console.log('unsubscribe', unsubscribe)
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (email) {
        window.scrollTo({
          top: window.innerHeight / 2,
          behavior: 'smooth',
        })
      } else
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
    }
    if (email) {
      obtainAll(email)
        .then(res => {
          setHasEmailSubscription(true)
          const { suscriptor_lt, suscriptor_pc } = res
          if (suscriptor_lt) {
            setCanSubscribeToLT(true)
          }
          if (suscriptor_pc) {
            setCanSubscribeToPC(true)
          }
          handleSubscriptionDataFromServer(res.newsletters, newsletters)
        })
        .catch(err => {
          console.log('email err', err)
        })
    }
  }, [email, triggerUnsubscribe])

  useEffect(() => {
    if (email) {
      optInThirdParty(email, optin)
        .then(res => {
          console.log('optin res', res)
        })
        .catch(err => {
          console.log('optin err', err)
        })
    }
  }, [optin])

  return (
    <div>
      {email ? (
        <>
          <div className="p-3 mx-auto md:max-w-screen-xl sm:p-8">
            <div className="md:w-9/12">
              <h6 className="mt-2 mb-0 leading-tight">Paso 2 de 2</h6>
              {<SecondStep email={email} unsubscribed={triggerUnsubscribe} />}
              <p className="pb-0 font-sans text-left">
                ¿No es tu correo electrónico?{' '}
                <a
                  className="underline text-azul hover:text-black"
                  href="#"
                  onClick={e => {
                    saveEmail('')
                    clearSubscriptions('')
                    setTriggerUnsubscribe(false)
                    setOptin('')
                    setCanSubscribeToLT(false)
                    setCanSubscribeToPC(false)
                    e.preventDefault()
                  }}>
                  Ingresa otro
                </a>
              </p>
            </div>
            {hasEmailSubscription === false ? (
              <div className="flex justify-center">
                <div className="w-12 h-12 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
              </div>
            ) : (
              <>
                {
                  <Reveal
                    triggerUnsubscribe={triggerUnsubscribe}
                    newsletters={newsletters}
                  />
                }
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="p-3 mx-auto md:max-w-screen-xl sm:p-8">
            <div className="md:w-9/12">
              <h6 className="mt-2 mb-0 leading-tight">
                Paso 1 de 2<br />
                <span className="block text-3xl leading-tight">
                  {firstStep}
                </span>
              </h6>
              <Form />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Steps
